import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';
import { IPPVPurchaseVerifyOtpPayload, IPPVPurchaseVerifyOtpResponse } from '../../../entity/interface/iEntitlements';
import { use } from 'react';

export interface IPPVPurchaseVerifyOtpUseCase {
    execute(
        payload: IPPVPurchaseVerifyOtpPayload,
        username: string,
        authToken: string,
        authSign: string,
        identityToken: string,
        csrfToken: { [key: string]: string },
        apiKey: string
    ): Promise<IPPVPurchaseVerifyOtpResponse>;
}

export class PPVPurchaseVerifyeOtpUseCase implements IPPVPurchaseVerifyOtpUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get qitafGenerateOtpRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        payload: IPPVPurchaseVerifyOtpPayload,
        username: string,
        authToken: string,
        authSign: string,
        identityToken: string,
        csrfToken: { [key: string]: string },
        apiKey: string
    ): Promise<IPPVPurchaseVerifyOtpResponse> {
        const response = await this.qitafGenerateOtpRepository.ppvPurchaseVerifyOtp(
            payload,
            username,
            authToken,
            authSign,
            identityToken,
            csrfToken,
            apiKey
        );
        return response;
    }
}
